import { Badge } from '../../containers/Badges/Models';
import * as React from 'react';
import PATHS from '../../constants/paths';
import { ToastComponent } from '../ToastComponent';
import useReactRouter from 'use-react-router';
import { useIntl } from 'react-intl';

interface BadgeToastProps {
  readonly badge: Badge;
}

export const BadgeToastComponent = (props: BadgeToastProps) => {
  const messageBase = 'components.Badges';
  const intl = useIntl();
  const { history } = useReactRouter();

  const title = intl.formatMessage({
    id: `${messageBase}.${props.badge.id}.title`,
  });

  const description = intl.formatMessage({
    id: `${messageBase}.${props.badge.id}.description`,
  });

  const toastTitle = intl.formatMessage({
    id: `${messageBase}.toast.title`,
  });

  const toastAction = intl.formatMessage({
    id: `${messageBase}.toast.action`,
  });

  const onButtonClick = () => history.push(PATHS.BADGES.INDEX);

  return (
    <ToastComponent
      infoTitle={toastTitle}
      title={title}
      description={description}
      iconName={props.badge.id}
      buttonTitle={toastAction}
      onButtonClick={onButtonClick}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/BadgeToast/index.tsx